var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',[_c('base-tl-checkbox',{attrs:{"value":"filterOnName1","label":_vm.label},nativeOn:{"click":function($event){return _vm.filterOnClick(_vm.filterOnName1, $event.target.checked)}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }